export const stringMapDefault = {
    /* TODO either add pre-defined message types or remove this */
    ariaLabelIcon: "warning",
    ariaLabelDismissButton: "Dismiss"
};
